// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { Card, Unstable_Grid2 as MuiGrid } from '@mui/material';

export function GridCard({ children, ...props }) {
    return (
        <MuiGrid xs={ 12 } sm={ 6 } md={ 4 } sx={{ display: 'flex', '@media print': { display: 'block', maxWidth: '100%', flexBasis: '100%' } }}>
            <Card
                style={{ backgroundColor: '#ffffff', height: '100%', width: '100%', boxShadow: '-10px 10px 20px 0 rgba(30, 30, 30, 0.05)' }}
                sx={{ '@media print': { height: 'auto', boxShadow: 'none', breakInside: 'auto', pageBreakInside: 'auto' } }}
                { ...props }
            >
                { children }
            </Card>
        </MuiGrid>
    );
}

GridCard.propTypes = {
    children: PropTypes.node.isRequired,
};

export const Grid = MuiGrid;

Grid.propTypes = {
    children: PropTypes.node.isRequired,
};

export function GridContainer({ children, ...props }) {
    return (
        <MuiGrid { ...props } container spacing={ 1 } alignItems='stretch'>
            { children }
        </MuiGrid>
    );
}

GridContainer.propTypes = {
    children: PropTypes.node.isRequired,
};
